// extracted by mini-css-extract-plugin
module.exports = {"AuthForm":"AuthForm_AuthForm__80z3C","Title":"AuthForm_Title__1WB3b","Input":"AuthForm_Input__ApP06","Switch":"AuthForm_Switch__3aPSE"};